import { Link } from "react-router-dom";

export type Crumb = {
  label: string;
  to?: string;
};

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="mb-5">
      <ol className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-1.5">
              {item.to && !isLast ? (
                <Link
                  to={item.to}
                  className="text-foreground-400 transition-colors hover:text-accent-500"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-foreground-700" : ""}>{item.label}</span>
              )}
              {!isLast ? <i className="ri-arrow-right-s-line text-foreground-600"></i> : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}